export const phraseStyles = {
  methods: {
    camelCaseToCapitalize (eventType) { // JohnDoe --> John doe
      const s = eventType.replace(/([A-Z])/g, ' $1')
      return s.charAt(1).toUpperCase() + (s.slice(2).toLowerCase())
    },
    camelCaseToProperCase (eventType) { // JohnDoe --> John Doe
      return eventType.replace(/([A-Z])/g, ' $1')
    },
    numberFormat (value) { // 1234567 --> 1,234,567
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
